// User Delegation API (Feature 2, CR-5889 out-of-office cover)
import api, { type AxiosResponse, type PaginatedResponse } from './client';
import type { EligibleDelegates, UserDelegation, UserDelegationInput } from './types';

/**
 * Out-of-office cover for the signed-in user. The backend always acts for the
 * caller at their active company, so no user or company is ever sent.
 */
export const delegationAPI = {
  /** The caller's time away and the time away they cover, at the active company. */
  list: (params?: Record<string, string | number | boolean>): Promise<AxiosResponse<PaginatedResponse<UserDelegation>>> =>
    api.get('/core/delegations/', { params }),

  get: (id: number): Promise<AxiosResponse<UserDelegation>> =>
    api.get(`/core/delegations/${id}/`),

  create: (data: UserDelegationInput): Promise<AxiosResponse<UserDelegation>> =>
    api.post('/core/delegations/', data),

  update: (id: number, data: Partial<UserDelegationInput>): Promise<AxiosResponse<UserDelegation>> =>
    api.patch(`/core/delegations/${id}/`, data),

  /** Turn time away off now, or cancel it before it starts. Nothing is ever deleted. */
  end: (id: number): Promise<AxiosResponse<UserDelegation>> =>
    api.post(`/core/delegations/${id}/end/`),

  /**
   * Colleagues who hold every approval right the caller holds — the only ones
   * who may cover — and the company's date today.
   */
  eligibleDelegates: (): Promise<AxiosResponse<EligibleDelegates>> =>
    api.get('/core/delegations/eligible-delegates/'),
};
